<script setup lang="ts">
import {
  getAddressSystemFromString,
  getAddressSystem,
} from '@sonarwatch/portfolio-core';
import { addressSystemLogos } from '@/constants';

const props = defineProps({
  address: { type: String, required: false },
  addressSystem: { type: String, required: false },
  size: { type: [Number, String], default: 16 },
  opacity: { type: Number, default: 1 },
});

const fAddressSystem = props.address
  ? getAddressSystem(props.address)
  : props.addressSystem
    ? getAddressSystemFromString(props.addressSystem)
    : null;
</script>

<template>
  <v-avatar
    v-if="fAddressSystem"
    :size="size"
    :image="addressSystemLogos[fAddressSystem]"
    rounded="0"
    :style="{ opacity: opacity }"
  />
</template>
